import { render, staticRenderFns } from "./Venue.vue?vue&type=template&id=5967a6d5&"
import script from "./Venue.vue?vue&type=script&lang=js&"
export * from "./Venue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports